import { render, staticRenderFns } from "./b_ChangePassword.vue?vue&type=template&id=2fe33c7e&scoped=true&"
import script from "./b_ChangePassword.vue?vue&type=script&lang=js&"
export * from "./b_ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./b_ChangePassword.vue?vue&type=style&index=0&id=2fe33c7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe33c7e",
  null
  
)

export default component.exports